// Single source of truth for sidebar nav order. Each key maps to a list route.
// `section` groups entries in the sidebar (defaults to 'Main').
export const RESOURCES = [
  { key: 'places', label: 'Places', path: '/places' },
  { key: 'itineraries', label: 'Itineraries', path: '/itineraries' },
  { key: 'activities', label: 'Activities', path: '/activities' },
  { key: 'states', label: 'States', path: '/states' },
  { key: 'food-preferences', label: 'Food Preferences', path: '/food-preferences' },
  { key: 'food-types', label: 'Food Types', path: '/food-types' },
  { key: 'group-types', label: 'Group Types', path: '/group-types' },
  { key: 'trip-types', label: 'Trip Types', path: '/trip-types' },
  { key: 'accommodation-preferences', label: 'Accommodation Prefs', path: '/accommodation-preferences' },
  { key: 'ads', label: 'Ads', path: '/ads' },
  { key: 'pages', label: 'Pages', path: '/pages' },
  { key: 'tabs', label: 'Tabs', path: '/tabs' },
  { key: 'notifications', label: 'Notifications', path: '/notifications' },
  { key: 'users', label: 'Users', path: '/users' },
  { key: 'admins', label: 'Admins', path: '/admins' },
  { key: 'feedback', label: 'Feedback', path: '/feedback' },
  { key: 'place-images', label: 'Image Moderation', path: '/place-images', section: 'Moderation' },
  { key: 'all-images', label: 'All Place Images', path: '/all-images', section: 'Moderation' },
  { key: 'moderate-destinations', label: 'Destination Moderation', path: '/moderate-destinations', section: 'Moderation' },
  { key: 'place-activities', label: 'Place Activities', path: '/place-activities', section: 'Moderation' },
  { key: 'hotels', label: 'Hotel Moderation', path: '/hotels', section: 'Moderation' },
  { key: 'restaurants', label: 'Restaurant Moderation', path: '/restaurants', section: 'Moderation' },
  { key: 'location', label: 'Location Moderation', path: '/location', section: 'Moderation' },
];
